module.exports = __webpack_public_path__ + "static/media/facebook.d08afb88.svg";